module.exports = __webpack_public_path__ + "static/media/b1.d7bc2fa6.webp";